module.exports = __webpack_public_path__ + "images/thumb-1d08a29bdac04faced2b8c15a778428b.jpg";